module.exports = __webpack_public_path__ + "img/PS-J-18.90057315.svg";